import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {catchError, Observable, throwError} from "rxjs";
import { environment } from 'src/environments/environment';
import {GeoLookupModel} from "../models/geo-lookup.model";
import { GetDocumentDetailRequest, GetMembershipAgreeementRequest} from "../models/document.request";
import {EventsManager} from "../events/events.manager";
import { MainPageDetailModel, PracticesDirectoryRequest, PracticesDirectoryResponse } from '../models/plans.model';
import {StateRequest} from "../models/state.request";
import {GrievanceRequest} from "../models/grievance.request";
import { HttpError } from '../core/http';
import {ContactUsRequestModel} from "../models/contact-us.request.model";
@Injectable({
  providedIn: 'root'
})
export class PlansService {

  constructor(private http: HttpClient,private em: EventsManager) { }

  getContactDetails(branding:string):Observable<any> {
    const url:string = `${environment.apiUrl}${environment.treatmentApi}practice/get-help-information?hint=`+branding;
    return this.http.get(url).pipe(
      catchError((e) => {
        return e;
      })
    )
  }

  getPlanDetails(options:StateRequest):Observable<any>{
    const url:string = `${environment.apiUrl}${environment.treatmentApi}purchase/portal/get-template-plan-options`;
    return this.http.get(url+'?Organization='+options.Organization+'&PlanPrefix='+options.PlanPrefix+'&State='+options.State).pipe(
      catchError((e) => {
        return e;
      })
    )
  }

  getPlanOptionsByState(options:StateRequest):Observable<any>{
    const url:string = `${environment.apiUrl}sales/services/get-plan-options-by-state`;
    return this.http.get(url+'?Organizationid='+options.Organization+'&PlanNamePrefix='+options.PlanPrefix+'&State='+options.State).pipe(
      catchError((e) => {
        return e;
      })
    )
  }

  getSellableStatesByPlan(options:string):Observable<any>{
    const url:string = `${environment.apiUrl}sales/plans/get-sellable-states-by-plan`;
    return this.http.get(url+'?planName='+options).pipe(
      catchError((e) => {
        return e;
      })
    )
  }

  getPlanOptionsByPractice(practiceId:string):Observable<any> {
      const practice = {practiceId:practiceId};
      const url:string = `${environment.apiUrl}${environment.treatmentApi}purchase/portal/get-template-plan-options`;
      return this.http.post(url, practice).pipe(
        catchError((e) => {
          return e;
        })
      )
    }

  getOffices(lookup:GeoLookupModel):Observable<any> {
    const url:string = `${environment.apiUrl}sales/purchase/portal/get-practices-by-zipcode`;
    return this.http.get(url+'?ZipCode='+lookup.zipCode+'&distance='+lookup.dist+'&organizationId='+lookup.org).pipe(
      catchError((e) => {
        return e;
      })
    )
  }

  getOrgId(site:string) {
    return '5D9799C4-81D0-41CE-8776-86CA5C8CF919';
  }

  getDocumentDetails(request: GetDocumentDetailRequest): Observable<any > {
    const url = `${environment.apiUrl}${environment.treatmentApi}member/get-document-details`;
    return this.http.post<string>(url, request).pipe(
      catchError((e: any) => {
        return e;
      }),
    );
  }

  getLegalLanguage(): Observable<any>{
    return this.http.get('data/language.json').pipe(
      catchError((e) => {
        return e;
      }),
    );
  }

  getMembershipAgreement(request: GetMembershipAgreeementRequest): Observable<Blob > {
    const requestUrl = `${environment.pdfUrl}print/plan-member-agreement?PracticeName=${request.practiceName}&PlanName=${request.planName}`;
    return this.http.get(requestUrl, { responseType: 'blob' });
  }

  sendGrievanceForm(request:GrievanceRequest): Observable<any > {
    const url = `${environment.salesApiUrl}services/send-grievance-email`;
    return this.http.post<string>(url, request).pipe(
      catchError((e: any) => {
        return e;
      }),
    );
  }

  getPracticesDirectory(request:PracticesDirectoryRequest):Observable<PracticesDirectoryResponse | HttpError>{
    const url = `${environment.apiUrl}${environment.treatmentApi}practices/get-directory`;
    return this.http.post<PracticesDirectoryResponse>(url, request).pipe(
      catchError((error) => {
          return throwError(() => error);
      }),
    );
  }

  getHomePageData(request:any):Observable<any>{
    const url:string = `${environment.apiUrl}sales/purchase/portal/get-marketing-details`;
    return this.http.get(url+'?PageName='+request.pageName+'&benefitPlanTemplateId='+request.planId).pipe(
      catchError((e) => {
        return e;
      })
    )
  }

  sendContactUs(request:ContactUsRequestModel):Observable<any>{
    const url:string = `${environment.apiUrl}sales/contact-us/send-email`;
    return this.http.post<any>(url, request).pipe(
      catchError((error) => {
        return throwError(() => error);
      }),
    );
  }
}
